import { find } from 'lodash';
import isEqual from 'react-fast-compare';

import store from '../store';
import { appActions } from '../store/modules/app';
import { PRODUCT_OPTION_NAME_SELECT_LIST } from '../constants/service/app/productConstants';

/**
 * 서버로에서 상품 데이터를 받아 올때, 옵션 모델 만들기
 */
export const setChoiceOption = (proStockAndOption) => {
  const choiceOptionKeyNameData = find(PRODUCT_OPTION_NAME_SELECT_LIST, { name: proStockAndOption.optionKeyName });

  return {
    /**
     *  선택된 옵션명의 ID
     */
    id: choiceOptionKeyNameData ? choiceOptionKeyNameData.id : 0,
    /**
     *  선택된 옵션명
     */
    name: proStockAndOption.optionKeyName,
    /**
     *  선택된 옵션값(CSV)
     */
    value: proStockAndOption.optionList.map((item) => item.name).join(','),
  };
};

/**
 * 상품 버전 데이터 비교
 */
export const compareProductVersion = (current, target) => {
  return !isEqual(current, target) ? 'different' : '';
};

/**
 * 상품 버전 정보 ([회차][등록일][수정자])
 */
export const setProductVersionInfo = (data, index) => {
  if (!data) return '';

  const { date, adminId, adminName, sellerId } = data;

  return `${index ? `${index} 회 ` : ''}${date} ${adminId ? `-관리자${adminName ? `(${adminName})` : ''}` : ''} ${
    sellerId ? '-판매자' : ''
  }`;
};

/**
 * 데이터 요청 시 스크린에 로딩 스피너를 노출 여부 결정
 * @param {boolean} loading 현재 데이터 로딩중인지 여부
 */
export const setFullScreenLoader = (loading) =>
  store.dispatch({ type: appActions.SET_FULLSCREEN_LOADER, payload: loading });

// 파라미터의 값이 빈문자열일때, 필터링 해주는 함수
export const removeEmptyString = (params) => {
  const newQuery = {};
  Object.keys(params).forEach((key) => {
    if (params[key] !== '') {
      newQuery[key] = params[key];
    }
  });
  return newQuery;
};

export const removeNull = (params) => {
  // eslint-disable-next-line no-unused-vars
  return Object.fromEntries(Object.entries(params).filter(([key, value]) => value !== null));
};

export const hasHyphen = (str) => {
  const regexPattern = /-/;
  return regexPattern.test(str);
};

export const onlyNum = (string) => {
  return string.replace(/[^0-9]/g, '');
};

export const addHyphenPhoneNum = (string) => {
  string = string.replace(/[^0-9]/g, '');
  string = string.replace(/(\d{3})(\d{4})(\d)/, '$1-$2-$3');
  return string.slice(0, 13);
};
